import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  company_name: string;
  isManager: boolean;
  role: string;
  email: string;
  name:string;
}

const initialState: UserState = {
  company_name: "",
  isManager: false,
  role: "",
  email: "",
  name:""
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserState>) {
      return { ...action.payload };
    },
    clearUser(state) {
      return initialState;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;